import { createIcon } from '@chakra-ui/icons'

const ICOIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#9B4FA6"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        ICO
      </text>
      <path
        d="M29.3 43.1c-3.1 0-5.7 2.5-5.7 5.7 0 3.1 2.5 5.7 5.7 5.7 3.1 0 5.7-2.5 5.7-5.7-.1-3.2-2.6-5.7-5.7-5.7zm0 9.7c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm15.6-1.3c-.4-.7-1.2-1.2-2.1-1.2h-.1c-.9 0-1.7.5-2.1 1.3l-6 11.9-1.9-2.8c-.4-.7-1.2-1.1-2-1.1s-1.5.4-2 1l-6.3 8.8c-.9 1.3-.6 3 .6 3.9.5.3 1 .5 1.6.5H53c1.5 0 2.8-1.2 2.8-2.8 0-.5-.1-1-.4-1.4L44.9 51.5zm9.3 20.1c-.2.4-.6.6-1 .6H24.8c-.6 0-1.2-.5-1.2-1.2 0-.2.1-.5.2-.7l6.3-8.8c.2-.2.4-.3.7-.3.3 0 .5.1.7.4l2.7 4c.2.2.4.4.7.4.3 0 .5-.2.7-.4l6.6-13.2c.1-.3.4-.4.7-.4.3 0 .6.1.7.4l10.6 18.2c.2.2.2.7 0 1z"
        fill="#E1E4EB"
      />
    </>
  ),
})

export default ICOIcon
